export const ADD_PATH_CACHE = "ADD_PATH_CACHE"
export const REMOVE_PATH_CACHE = "REMOVE_PATH_CACHE"
export const CLEAR_PATH_CACHES = "CLEAR_PATH_CACHES"
